import moment from "moment"
moment.locale("zh-cn")


export function getSearchParm(obj){
    return new Proxy(obj,{
        get(target,key){
            if(target[key] == ""||target==null){
                return undefined
            }
		    if((key == "tt1"||key=="tt2") && moment.isMoment(target[key])){
				return target[key].format("YYYY-MM-DD"); 
		    }
			return target[key]
	    }
    })
}

export const excelheader = {
	"合同名称":"name",
	"合同金额":"price",
	"签署日期":"yiDate",
	"乙方姓名":"yi",
	"乙方电话":"yiPhone",
	"乙方所在工地":"yiWorkPlace",
}

export const columns = [
    {dataIndex:"id",key:"id",title:"序号",scopedSlots: { customRender: 'tindex' }},
    {dataIndex:"name",key:"name",title:"合同名称"},
    {dataIndex:"price",key:"price",title:"合同金额"},
    {dataIndex:"yiDate",key:"yiDate",title:"签署日期"},
    {dataIndex:"yi",key:"yi",title:"乙方姓名"},
    {dataIndex:"yiPhone",key:"yiPhone",title:"乙方电话"},
    {dataIndex:"yiWorkPlace",key:"yiWorkPlace",title:"乙方所在工地"},
    {key:"action",title:"操作",align:"center",scopedSlots: { customRender: 'action' }},
]




